import { CollapsibleMethods, Button, Collapsible, Body, colors } from '@spritz-finance/ui'
import { useState, useRef } from 'react'
import styled from 'styled-components'
import { ExpandDetailIcon } from '../../../../../components/ExpandedDetailIcon'
import { Column } from '../../../../../components/Layout/Column'
import { Row } from '../../../../../components/Layout/Row'
import { TokenBalance } from '../../../../../graphql/generated/graphql'

const InfoWrapper = styled.div`
    padding: 16px;
    border-radius: 10px;
    background: var(--surface-3, ${colors.silverGray});
    max-width: 495px;
`
const InlineButton = styled(Body.Med)`
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`

export const AllowanceInfo = ({ token }: { token: TokenBalance }) => {
    const [open, setOpen] = useState(false)
    const content = useRef<CollapsibleMethods>(null)
    const toggle = () => {
        content.current?.toggle()
        setOpen((curr) => !curr)
    }
    return (
        <Column align="center">
            <Row align="center">
                <Button.Text onClick={toggle}>Why do I need to give permission?</Button.Text>
                <ExpandDetailIcon active={open} size={24} style={{ marginLeft: -8 }} />
            </Row>
            <Collapsible ref={content} defaultOpen={false}>
                <InfoWrapper>
                    <Column align="center">
                        <Body.Med size={14} align="center">
                            This is the first time you are paying with {token.symbol} from this
                            wallet. You will need to give the Spritz smart contract approval to
                            access your {token.symbol} before you can make a payment. &nbsp;
                            <InlineButton
                                onClick={() => {
                                    window.open(
                                        'https://help.spritz.finance/en/articles/6958701-why-do-i-need-to-give-spritz-permission-to-access-my-wallet'
                                    )
                                }}
                                size={14}
                            >
                                Learn more
                            </InlineButton>
                        </Body.Med>
                    </Column>
                </InfoWrapper>
            </Collapsible>
        </Column>
    )
}
